module.exports = __webpack_public_path__ + "4c3d669e38da55830f70e2756919dcec.png";